export default function NetworkLab() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">🌐 Network Lab</h1>

      <div className="bg-white/5 border border-gray-800 rounded-xl p-8">
        <p className="text-gray-400">
          This lab simulates real-world networking like Cisco Packet Tracer.
        </p>

        <div className="mt-6 p-6 border border-dashed border-gray-600 rounded-lg text-center">
          🛠️ Network Simulation Engine  
          <br />
          <span className="text-yellow-400 font-semibold">
            Coming Soon
          </span>
        </div>
      </div>
    </div>
  );
}
